<div class="row page-header">
    <div class="col-12">
        <h1>Actions <small>Execute specific actions on the server</small></h1>
    </div>
</div>
@if (canEdit) {
    <div class="d-flex flex-wrap gap-2">
        <button class="btn btn-secondary" (click)="slackTest()">Slack Test</button>
        <button class="btn btn-secondary" (click)="clearCache()">Clear Vista Cache</button>
        <button class="btn btn-secondary" (click)="syncBidAnalysisLookups()">Update Bid Analysis Lookups</button>
        <button class="btn btn-secondary" (click)="syncVpPhaseActivityLookup()">Sync Vista Activity Codes to WebTools</button>
        <button class="btn btn-secondary" (click)="estimateFileInput.click()">Import Estimates</button>
        <button class="btn btn-secondary" (click)="hcssActivityFileInput.click()">Import HCSS Activities</button>
        <button class="btn btn-secondary" (click)="vistaAutomationTest()">Vista Automation Test</button>
        <button class="btn btn-secondary" (click)="openVoiceDictation()">Voice Dictation POC</button>
        <button
            class="btn btn-outline-warning"
            (click)="testSessionExpiredRedirect()"
            title="Calls an API that returns 401 to test session-expired redirect"
        >
            Test session expired (401)
        </button>
    </div>
    <input #estimateFileInput type="file" accept=".xlsx,.xls" style="display: none" (change)="onEstimateFileSelected($event)" />
    <input #hcssActivityFileInput type="file" accept=".xlsx,.xls" style="display: none" (change)="onHcssActivityFileSelected($event)" />
}
<div style="margin-top: 10px">
    @if (cacheCreatedDate) {
        <div>
            <div>Cache created on {{ cacheCreatedDate | date: 'short' }}</div>
            <div>Cache expires on {{ cacheExpirationDate | date: 'short' }}</div>
        </div>
    } @else {
        <div>
            <span>No cache created</span>
        </div>
    }
</div>

@if (canEdit && vistaTestRan) {
    <div style="margin-top: 20px">
        <h4>Vista Automation Test <small>bulk inserts directories</small></h4>

        @if (vistaTestError) {
            <div class="alert alert-danger" style="margin-top: 10px">
                <strong>Error:</strong> {{ vistaTestError }}
            </div>
        } @else if (vistaTestDirectories.length > 0) {
            <div class="alert alert-success" style="margin-top: 10px">
                Found {{ vistaTestDirectories.length }} director{{ vistaTestDirectories.length === 1 ? 'y' : 'ies' }} in
                <code>{{ vistaTestPath }}</code>
            </div>
            <ul class="list-group" style="max-width: 600px">
                @for (dir of vistaTestDirectories; track dir) {
                    <li class="list-group-item">{{ dir }}</li>
                }
            </ul>
        } @else {
            <div class="alert alert-warning" style="margin-top: 10px">
                Connected successfully, but no directories were found in <code>{{ vistaTestPath }}</code>.
            </div>
        }
    </div>
}

@if (canEdit) {
    <div style="margin-top: 20px">
        <h4>Outlook Email Test <small>VanConAP inbox</small></h4>
        <button class="btn btn-info" (click)="testOutlookEmail()">Test Outlook Email (10 most recent)</button>

        @if (outlookTestRan && outlookTestError) {
            <div class="alert alert-danger" style="margin-top: 10px">
                <strong>Error:</strong> {{ outlookTestError }}
            </div>
        }

        @if (outlookTestRan && outlookTestResults.length > 0) {
            <table class="table table-striped table-sm" style="margin-top: 10px">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Subject</th>
                        <th>Received</th>
                        <th>Attachments</th>
                    </tr>
                </thead>
                <tbody>
                    @for (msg of outlookTestResults; track msg.receivedDateTime; let i = $index) {
                        <tr>
                            <td>{{ i + 1 }}</td>
                            <td>{{ msg.subject }}</td>
                            <td>{{ msg.receivedDateTime | date: 'short' }}</td>
                            <td>
                                @if (msg.attachments.length === 0) {
                                    <span class="text-muted">None</span>
                                } @else {
                                    @for (att of msg.attachments; track att.id) {
                                        <div>
                                            <fa-icon [icon]="getFileIcon(att.name)" [fixedWidth]="true" class="me-1"></fa-icon>
                                            <a role="button" class="text-primary" style="cursor: pointer; text-decoration: underline;"
                                                (click)="previewAttachment(msg.messageId, att.id)">{{ att.name }}</a>
                                        </div>
                                    }
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        }

        @if (outlookTestRan && !outlookTestError && outlookTestResults.length === 0) {
            <div class="alert alert-warning" style="margin-top: 10px">
                No emails found in the VanConAP inbox.
            </div>
        }
    </div>
}
